
import { Box, Button, Typography } from "@mui/material";
import React, { FC, useState } from "react";
// import { usePostQueryWithJwtMutation } from "../../redux/api/cabinet";


import { useNavigate } from "react-router-dom";
import { usePostBodyWithJwtMutation } from "src/redux/api/cabinet";
import { palette } from "src/theme/style/palette";
import { Alerting } from "src/views/components_cabinet/Alerting";


interface ILoadImgForAds {
    id: any
    updateState?: () => void
    reload?: () => void
}

export const LoadImgForAds: FC<ILoadImgForAds> = ({ id: exchange, updateState, reload }) => {
    const [getAlert, setGetAlert] = useState<{ type: number; msg: string } | undefined>(undefined);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [previewUrl, setPreviewUrl] = useState<string | null>(null);
    const allowedFormats = ["image/jpeg", "image/png", "image/webp", "image/heic", "image/heif"];
    const nav = useNavigate();

    const [postData, { isLoading }] = usePostBodyWithJwtMutation();

    const registerAnswer = async (body: any) => {
        const route = "send-receipt";
        const jwt = localStorage.getItem("jwt");
        try {
            // const payload = 
            await postData({ body, route, jwt }).unwrap();

            nav("/office/p2p/broni");
            updateState && updateState();
            reload && reload();

        } catch (error: any) {
            setGetAlert({ type: 2, msg: error.data.message });
        }
    };

    const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const file = event.target.files?.[0];

        if (file) {
            if (!allowedFormats.includes(file.type)) {
                setGetAlert({ type: 2, msg: "Неверный формат файла. Поддерживаются JPG, PNG, GIF, WebP, HEIC, HEIF." });
                setSelectedFile(null);
                setPreviewUrl(null);
                return;
            }

            setSelectedFile(file);
            setPreviewUrl(URL.createObjectURL(file));
        }
    };

    const handleUpload = () => {
        if (selectedFile) {
            // console.log(selectedFile);

            const formData = new FormData();

            // Добавление картинки в FormData
            formData.append("receipt", selectedFile);

            // Добавление exchange.id в FormData
            formData.append("exchange", String(exchange.id));

            // Отправка данных через registerAnswer
            registerAnswer(formData);
        } else {
            setGetAlert({ type: 2, msg: "Картинка не найдена" });
        }
    };

    console.log(exchange);


    return (
        <>
            {getAlert && <Alerting get={getAlert} />}

            <Box width="100%" mt={3} textAlign="center">
                <Typography variant="h5">Вы забронировали объявление №{exchange.id}!</Typography>

                <Box sx={{ my: 2, p: 1, borderRadius: '4px', background: palette.blueLight, minHeight: '200px' }}>
                    <Typography variant="h6" mb={2}>
                        Реквизиты для платежа:
                    </Typography>
                    <Typography variant="body1" >
                        {exchange?.account || "Реквизиты не найдены"}
                    </Typography>
                </Box>

                <Typography variant="body1" mt={2}>
                    Чтобы подтвердить оплату, загрузите скриншот с подтверждением платежа.
                </Typography>

                <Box mt={2}>
                    <input
                        type="file"
                        accept="image/jpeg, image/png, image/gif, image/webp, image/heic, image/heif"
                        style={{ display: "none" }}
                        id="file-upload"
                        onChange={handleFileChange}
                    />
                    <label htmlFor="file-upload">
                        <Button variant="outlined" component="span">
                            Выбрать файл
                        </Button>
                    </label>

                    {selectedFile && (
                        <Typography variant="body2" mt={1}>
                            Выбран файл: {selectedFile.name}
                        </Typography>
                    )}
                </Box>

                {/* Предпросмотр изображения */}
                {previewUrl && (
                    <Box mt={2} display="flex" justifyContent="center">
                        <img
                            src={previewUrl}
                            alt="Предпросмотр"
                            style={{ maxWidth: "100%", maxHeight: "300px", borderRadius: "8px" }}
                        />
                    </Box>
                )}

                <Box mt={2}>
                    <Button variant="contained" onClick={handleUpload} disabled={!selectedFile || isLoading}>
                        Загрузить
                    </Button>
                </Box>
            </Box>
        </>
    )
}
